import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/globals.css';

// Import Layout component
import Layout from './components/Layout/Layout';

// Import context providers
import { AppProvider } from './context/AppContext';
import { ThemeProvider } from './context/ThemeContext';

// Initialize theme from localStorage before rendering
const initializeTheme = () => {
  try {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light' || savedTheme === 'dark') {
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
  } catch (error) {
    console.error('Error initializing theme:', error);
  }
};

// Initialize theme before rendering to prevent flash
initializeTheme();

// Import pages
import HomePage from './pages/index';
import VehicleRidePage from './pages/vehicle-ride/[id]';
import SimulationPage from './pages/simulation';

// Render the app
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/vehicle-ride/:id/" element={<VehicleRidePage />} />
              <Route path="/simulation" element={<SimulationPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    </AppProvider>
  </React.StrictMode>
);
